import React from "react";
import s from "@/components/Buttons/Button.module.scss";

const Button = ({ text, type, loading, processingLabel, margin, handleClick }) => {
  const buttonTheme = window.post_template.checkout_v6_global_components?.checkout_v6_components_btnTheme;

  return (
    <button
      onClick={handleClick}
      data-testid="cc-complete-order"
      style={{ marginTop: margin && margin + "px" }}
      className={`${s.button} ${s.button__submit}`}
      id="hook-form"
      type={type}
      theme={buttonTheme}
      loading={`${String(loading)}`}
    >
      <span className={s.processing}>{processingLabel}</span>
      <span className={s["button__submit--loading"]}></span>
      <span className={s["button__submit--text"]}>{text}</span>
    </button>
  );
};

export default Button;
